export enum AlertLayout {
	Primary = 'alert alert-primary',
	Secondary = 'alert alert-secondary',
	Success = 'alert alert-success',
	Danger = 'alert alert-danger',
	Warning = 'alert alert-warning',
	Info = 'alert alert-info',
	Light = 'alert alert-light',
	Dark = 'alert alert-dark',
}
